/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Status of suggested option
 */
export enum SuggestionFeedbackStatus {
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}
